import { TransferTypeOptions } from '~/repositories/Transfer/TransferRepository';

export const toggleInArray = <T>(array: T[] = [], item: T): T[] => {
  const set = new Set(array);
  if (set.has(item)) {
    set.delete(item);
  } else {
    set.add(item);
  }
  return Array.from(set);
};

export const normalizeTransferTypes = (types: unknown[] | undefined): (typeof TransferTypeOptions)[number][] => {
  if (!Array.isArray(types)) {
    return [];
  }
  const allowed = new Set<string>(TransferTypeOptions as readonly string[]);
  return types.filter((t) => allowed.has(String(t))) as (typeof TransferTypeOptions)[number][];
};

export const joinOrUndefined = (values?: string[]): string | undefined => {
  return values && values.length > 0 ? values.join(',') : undefined;
};

export const isEmptyObject = (value: unknown): boolean => {
  return typeof value === 'object' && value !== null && Object.keys(value as Record<string, unknown>).length === 0;
};
